<mat-dialog-content>
  <div class="dialog-content">
    <ng-container *ngIf="loaded">
      <div class="start-calendar">
        <label>Select the first date</label>
        <mat-calendar [dateFilter]="timeseriesFilter" [minDate]="minDate" [maxDate]="maxDate" [startAt]="minDate"
          [(selected)]="startDate"></mat-calendar>
      </div>
      <mat-divider vertical></mat-divider>
      <div class="end-calendar">
        <label>Select the last date</label>
        <mat-calendar [dateFilter]="timeseriesFilter" [minDate]="minDate" [maxDate]="maxDate" [startAt]="maxDate"
          [(selected)]="endDate"></mat-calendar>
        <!-- <label class="end-date-selected">Selecting an enddate will show the timeseries graph spanning start to enddate.</label> -->
      </div>
    </ng-container>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-raised-button [disabled]="!startDate" (click)="addDataset()">Show timeseries</button>
</mat-dialog-actions>
